"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=Religion.js.map